var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup237596(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35,
    fill: "white",
    stroke: "#EBA10F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8889 37.6667H35.5V49.4792V50.1481L36.1415 49.9588C41.7248 48.3112 45.8178 43.073 46.6066 37.2197L46.683 36.6529H46.1111H36.5V25.0195V24.2644L35.8048 24.5592L25.6937 28.8473L25.3889 28.9765V29.3076V37.1667V37.6667H25.8889ZM23.5 35.7879V27.8462L36 22.5431L48.5 27.8462V35.7879C48.5 43.1747 43.1642 50.0903 36 51.8195C28.8358 50.0903 23.5 43.1747 23.5 35.7879Z",
    fill: "#EBA10F",
    stroke: "#EBA10F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup237596);
export default __webpack_public_path__ + "static/media/Group 237596.acf30c7ff12c531c4672733c085e530a.svg";
export { ForwardRef as ReactComponent };